/**
 * BillingData Entity Definition
 */
import { BillingDataRelationSchema } from "../schemas/relations";
import { defineEntity } from "./core";
export const BillingDataEntityDef = defineEntity({
    name: "billing-data",
    schema: BillingDataRelationSchema,
    relations: {},
});
